import { render, staticRenderFns } from "./ZisPortal.vue?vue&type=template&id=f1e2dd2e"
import script from "./ZisPortal.vue?vue&type=script&lang=js"
export * from "./ZisPortal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports